const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.%]+$/i;

export function isValidUrl(str: string): boolean {
    return pattern.test(str);
}
